'use client';

import { RecordDetailsLoaderProvider, type RecordDetails } from '@repo/ui/record-chip-popover';
import { apiFetch } from '@/lib/fetch';

// Feeds the record chip popover (packages/ui) from /api/records/:id.
async function loadRecordDetails(recordId: string): Promise<RecordDetails | null> {
    const res = await apiFetch(`/api/records/${recordId}`);
    if (!res.ok) return null;
    const json = await res.json();
    const record = json.data ?? json;
    return {
        name: record.name,
        companies: Array.isArray(record.parent_companies) && record.parent_companies.length > 0
            ? record.parent_companies.map((c: { name: string }) => c.name)
            : null,
        address: record.address ?? null,
        city: record.city ?? null,
        state: record.state ?? null,
        zip: record.zip ?? null,
        // One Phone row rather than four. Organizations carry the number
        // on phone_business far more often than on the generic `phone`
        // column, so prefer it and fall back.
        phone: record.phone_business ?? record.phone ?? null,
        email: record.email ?? null,
        record_subtype: record.record_subtype ?? null,
        tags: record.tags ?? null,
    };
}

export function RecordDetailsProvider({ children }: { children: React.ReactNode }) {
    return <RecordDetailsLoaderProvider loader={loadRecordDetails}>{children}</RecordDetailsLoaderProvider>;
}
